<form class="form" [formGroup]="form">
  <div class="contacts" formArrayName="contacts">
    <div
      *ngFor="let contact of contacts.controls; let cIndex = index"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
    >
      <div class="item" [formGroupName]="cIndex">
        <div *ngIf="showFieldCounter || allowEditing" class="item__header">
          <div *ngIf="showFieldCounter" class="title text_size-m text_bold text_color-01">Поле {{ cIndex + 1 }}</div>
          <div class="buttons">
            <button
              *ngIf="allowEditing"
              tuiIconButton
              type="button"
              iconStart="@tui.chevron-up"
              appearance="outline-grayscale"
              tuiAppearanceMode="checked"
              [size]="'m'"
              [disabled]="cIndex === 0 || disabled"
              (click)="moveContact(cIndex, -1)"
            ></button>

            <button
              *ngIf="allowEditing"
              tuiIconButton
              type="button"
              iconStart="@tui.chevron-down"
              appearance="outline-grayscale"
              tuiAppearanceMode="checked"
              [size]="'m'"
              [disabled]="cIndex === contacts.controls.length - 1 || disabled"
              (click)="moveContact(cIndex, 1)"
            ></button>

            <button
              *ngIf="allowDeleting"
              tuiIconButton
              type="button"
              iconStart="@tui.trash-2"
              appearance="outline-grayscale"
              tuiAppearanceMode="checked"
              [disabled]="disabled"
              [size]="'m'"
              (click)="removeContact(cIndex)"
            ></button>
          </div>
        </div>

        <!-- Тип поля -->
        <div *ngIf="allowEditing" class="item__type">
          <tui-select
            tabindex="20"
            formControlName="contactTypeId"
            [valueContent]="contactTypes ? contactTypesStringify(contactTypes) : ''"
            [tuiTextfieldSize]="tuiElementLargeSize"
            [class.tui-skeleton]="loading"
            [class.tui-skeleton_text]="loading"
          >
            {{ 'components.contacts.fields.contactType' | translate }}
            <tui-data-list *tuiDataList>
              <button *ngFor="let contactType of contactTypes" tuiOption [value]="contactType.id">
                {{ contactType.description | translate }}
              </button>
            </tui-data-list>
          </tui-select>
        </div>

        <!-- Название поля -->
        <div *ngIf="allowEditing" class="item__description">
          <tui-input
            class="title"
            tabindex="21"
            formControlName="description"
            [tuiTextfieldSize]="tuiElementLargeSize"
            [class.tui-skeleton]="loading"
            [class.tui-skeleton_text]="loading"
          >
            {{ 'components.contacts.fields.contactName' | translate }}
          </tui-input>

          <app-field-wrapper-old
            *ngxPermissionsOnly="['contactsRequireValueEditing']"
            [label]="'common.labels.required' | translate"
            [class.tui-skeleton]="loading"
            [class.tui-skeleton_text]="loading"
            [size]="tuiElementMediumSize"
          >
            <app-toggle formControlName="isRequired" [size]="tuiElementMediumSize"></app-toggle>
          </app-field-wrapper-old>
        </div>

        <!-- Значение поля -->
        <div class="item__value">
          <!-- Поле не является ни Прочим, ни файлом -->
          <tui-input
            *ngIf="showFieldValue && isNotOtherAndNotFileAndNotListContactLocal(contact.value.contactTypeId)"
            tabindex="22"
            formControlName="contact"
            [tuiTextfieldSize]="tuiElementLargeSize"
            [class.tui-skeleton]="loading"
            [class.tui-skeleton_text]="loading"
          >
            {{ allowEditing ? ('components.contacts.fields.contactValue' | translate) : contact.value.description }}
            <span *ngIf="contact.value.isRequired" class="tui-required"></span>
          </tui-input>

          <!-- Поле является Прочим -->
          <tui-textarea
            *ngIf="showFieldValue && isOtherContactLocal(contact.value.contactTypeId)"
            class="field_height_min"
            tabindex="22"
            formControlName="contact"
            [tuiTextfieldSize]="tuiElementLargeSize"
            [class.tui-skeleton]="loading"
            [class.tui-skeleton_text]="loading"
            [expandable]="true"
          >
            {{ allowEditing ? ('components.contacts.fields.contactValue' | translate) : contact.value.description }}
            <span *ngIf="contact.value.isRequired" class="tui-required"></span>
          </tui-textarea>

          <!-- Поле является файлом -->
          <ng-container *ngIf="showFieldValue && isFileContactLocal(contact.value.contactTypeId)">
            <app-label [label]="allowEditing ? '' : contact.value.description">
              <span *ngIf="!allowEditing && contact.value.isRequired" class="tui-required"></span>

              <app-input-files
                *ngIf="!!getDocumentFormControl(contact, 'oldDocument').value; else newDocumentTmp"
                tabindex="22"
                formControlName="oldDocument"
                [link]="'common.fields.fileLink' | translate"
                [label]="' '"
                [maxFileSize]="maxDocFileSize"
                [size]="tuiElementLargeSize"
                [accept]="acceptFiles"
                [loading]="loading"
                [showDelete]="!!allowFilesDeleting"
                [isModeration]="!!isModeration"
                (removed)="resetDocumentFormControl(contact, 'oldDocument')"
              ></app-input-files>

              <ng-template #newDocumentTmp>
                <app-input-files
                  tabindex="22"
                  formControlName="newDocument"
                  [link]="'common.fields.fileLink' | translate"
                  [label]="' '"
                  [maxFileSize]="maxDocFileSize"
                  [size]="tuiElementLargeSize"
                  [accept]="acceptFiles"
                  [loading]="loading"
                  (removed)="resetDocumentFormControl(contact, 'newDocument')"
                ></app-input-files>
              </ng-template>

              <tui-error
                *ngIf="contact.hasError('atLeastOne')"
                [error]="'components.contacts.labels.documentRequired' | translate"
              ></tui-error>
            </app-label>
          </ng-container>

          <div *ngIf="isListContactLocal(contact.value.contactTypeId)" class="contact-list">
            <tui-select
              *ngIf="allowEditing"
              formControlName="customListId"
              [valueContent]="
                customListDirectories$.value ? contactCustomListStringify(customListDirectories$.value) : ''
              "
              [tuiTextfieldSize]="tuiElementLargeSize"
              [class.tui-skeleton]="loading"
              [class.tui-skeleton_text]="loading"
            >
              {{ 'components.contacts.fields.contactDirectoryName' | translate }}
              <span class="tui-required"></span>
              <tui-data-list *tuiDataList>
                <button *ngFor="let item of customListDirectories$ | async" tuiOption [value]="item.id">
                  {{ item.title }}
                </button>
              </tui-data-list>
            </tui-select>

            <ng-container *ngIf="showFieldValue">
              <tui-select
                *tuiLet="contact.get('contactListValues')?.value as values"
                formControlName="customListValueId"
                [valueContent]="values ? contactCustomListStringify(values) : ''"
                [tuiTextfieldSize]="tuiElementLargeSize"
                [class.tui-skeleton]="loading"
                [class.tui-skeleton_text]="loading"
              >
                {{ allowEditing ? ('components.contacts.fields.contactValue' | translate) : contact.value.description }}
                <span *ngIf="contact.value.isRequired" class="tui-required"></span>
                <tui-data-list *tuiDataList>
                  <button *ngFor="let item of values" tuiOption [value]="item.id">
                    {{ item.title }}
                  </button>
                </tui-data-list>
              </tui-select>
            </ng-container>
          </div>
        </div>
      </div>

      <div *ngIf="showFieldSeparator" class="separator"></div>
    </div>

    <div
      *ngIf="!disabled && allowCreating"
      tuiGroup
      class="add-button"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
      [collapsed]="true"
    >
      <button
        tuiButton
        appearance="outline-grayscale"
        tuiAppearanceMode="checked"
        [size]="'m'"
        type="button"
        (click)="addContact()"
      >
        {{ 'components.contacts.buttons.addField' | translate }}
      </button>

      <button
        *ngIf="!disabled && allowCreating"
        tuiIconButton
        class="tui-group__auto-width-item"
        appearance="outline-grayscale"
        tuiAppearanceMode="checked"
        iconStart="@tui.circle-plus"
        [size]="'m'"
        type="button"
        (click)="addContact()"
      ></button>
    </div>
  </div>
</form>
